export const formatDataOnSubmit = (data: any) => {
  if (!data.identifier) {
    return data;
  }

  return {
    ...data,
    identifier: data.identifier.value,
  };
};

export default formatDataOnSubmit;
